import { navLinks } from "@/mocks/home";

export default function Footer() {
  const goTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <footer className="bg-secondary-900 text-background-100">
      <div className="max-w-content mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center">
                <i className="ri-book-open-line text-lg" />
              </span>
              <span className="font-heading text-lg font-semibold">年轻的岳母</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-200 max-w-md">
              一个围绕《年轻的岳母》整理的阅读场景页：集中呈现漫画、小说、同人与番外本子的内容说明，梳理人物关系与卷章脉络，并记录更新节奏，方便读者按需查找。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              <span className="px-2.5 py-1 rounded-full bg-secondary-800 text-background-200 text-xs whitespace-nowrap">家庭成长向</span>
              <span className="px-2.5 py-1 rounded-full bg-secondary-800 text-background-200 text-xs whitespace-nowrap">剧情 · 同人</span>
              <span className="px-2.5 py-1 rounded-full bg-secondary-800 text-background-200 text-xs whitespace-nowrap">阅读索引</span>
            </div>
          </div>

          <div className="lg:col-span-4">
            <h3 className="text-sm font-medium text-background-50">页内导航</h3>
            <ul className="mt-4 grid grid-cols-2 gap-x-6 gap-y-2.5">
              {navLinks.map((link) => (
                <li key={link.id}>
                  <button
                    type="button"
                    onClick={() => goTo(link.id)}
                    className="text-sm text-background-200 hover:text-accent-400 cursor-pointer whitespace-nowrap transition-colors"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h3 className="text-sm font-medium text-background-50">内容说明</h3>
            <ul className="mt-4 flex flex-col gap-2.5 text-sm text-background-200">
              <li className="flex items-start gap-2">
                <i className="ri-checkbox-circle-line mt-0.5 text-accent-400" />
                全部内容仅在本页展示
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-checkbox-circle-line mt-0.5 text-accent-400" />
                筛选仅作用于已有条目
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-checkbox-circle-line mt-0.5 text-accent-400" />
                不收集账号与个人信息
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-800 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-xs text-background-300">
            本页面为演示用的内容整理页，条目信息用于说明阅读场景的组织方式，不代表真实出版或更新状态。
          </p>
          <button
            type="button"
            onClick={() => goTo("top")}
            className="inline-flex items-center gap-2 text-xs text-background-200 hover:text-accent-400 cursor-pointer whitespace-nowrap transition-colors"
          >
            <i className="ri-arrow-up-line" />
            回到顶部
          </button>
        </div>
      </div>
    </footer>
  );
}